import React, { useState, useEffect } from "react";
import { Form, Input, Upload, Icon } from "antd";
import { Modal } from '../../../helpers/commonUi'
import style from "../orgs.module.sass";
import { Http } from "../../../helpers/axois";
import { useParams } from "react-router-dom";
import { useToast } from '../../../helpers/commonFunction'

interface IProps {
    visible: boolean;
    setVisible: any;
    data: any;
    refresh: any;
    setRefresh: any;
    selectedOrgId?: string;
}

const { TextArea } = Input;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
    }
};

function getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
}

const initialdata = {
    name: "",
    primaryEmail: "",
    description: "",
    img: ""
};

const initialValidationState = {
    name: "",
    primaryEmail: "",
    description: "",
    img: ""
};
const Initialstate = {
    img: "",
    loading: false,
    previewVisible: false,
    editing: true
};

const EditCreateTeam = (props: IProps) => {
    const [state, setmodaldata]: any = useState(Initialstate);
    const [valstate, setValstate]: any = useState(initialValidationState);
    const [formstate, setformstate]: any = useState({ ...initialdata });
    const [teamErrors, setTeamErrors] = useState<string>("");
    const [prevTeamName, setPrevTeamName] = useState("")
    const { ErrorToast, SuccessToast } = useToast() 
    let { orgId } = useParams<any>();
    const { selectedOrgId } = props;

    // useEffect(() => {
    //     if (orgId && teamId) {
    //         setmodaldata({
    //             loading: true
    //         });
    //         Http.get(`/team/${teamId}/${orgId}`).subscribe((res: any) => {
    //             let { teamName, description, profilePhoto } = res[0];
    //             setformstate({
    //                 description: description,
    //                 name: teamName,
    //                 img: profilePhoto
    //             });
    //             setmodaldata({
    //                 loading: false
    //             });
    //         });
    //     }
    // }, [orgId, teamId]);

    useEffect(() => {
        if (props.data.id) {
            let { teamName, description, profilePhoto } = props.data;
            setPrevTeamName(teamName)
            setformstate({
                description: description,
                name: teamName,
                img: profilePhoto
            });
        } else {
            setformstate({ ...initialdata })
        }
    }, [props.data]);

    const formsetState = (key: any) => (e: any) => {
        setTeamErrors("")
        const format = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
        if (!format.test(e.target.value)) {
            setformstate({
                ...formstate,
                [key]: e.target.value
            });
        }
        e.target.value === ""
            ? checkvalidation(key, `${key} required`)
            : checkvalidation(key, ``);
    };

    const checkvalidation = (name: string, errmsg: string) => {
        setValstate({
            ...valstate,
            [name]: errmsg
        });
    };

    function beforeUpload(file: any) {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            setmodaldata({
                ...formstate,
                loading: false
            });
            checkvalidation("img", "You can only upload JPG/PNG file!");
            setTimeout(() => {
                checkvalidation("img", "");
            }, 2000);
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            setmodaldata({
                ...formstate,
                loading: false
            });
            checkvalidation("img", "Image must smaller than 2MB!");
            setTimeout(() => {
                checkvalidation("img", "");
            }, 2000);
        }
        return isJpgOrPng && isLt2M;
    }
    const handleChange = (info: any) => {
        if (info.file.status === "uploading") {
            setmodaldata({
                ...formstate,
                loading: true
            });
            return;
        }
        if (info.file.status === "done") {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, (imageUrl: any) => {
                setmodaldata({ loading: false, img: info.file.originFileObj });
                setformstate({ ...formstate, img: imageUrl });
                checkvalidation("img", "");
            });
        } else if (info.file.status === "error") {
            setmodaldata({ loading: false, img: info.file.originFileObj });
            checkvalidation("img", "file upload failed.");
            setTimeout(() => {
                checkvalidation("img", "");
            }, 1000);
        }
    };

    const handleOK = () => {

        if (formstate.name.trim() === "") {
            ErrorToast('Please fill the mandatory fields')
            setValstate({
                ...valstate,
                name: `name required`,
            });
            return
        }

        if (formstate.description.trim() === "") {
            ErrorToast('Please fill the mandatory fields')
            setValstate({
                ...valstate,
                description: "description required"
            });
            return
        }

        const formData = new FormData();
        state.img && formData.append("profilePhoto", state.img);
        if (prevTeamName !== formstate.name.trim()) {
            formData.append("teamName", formstate.name.trim());
        }
        formData.append("description", formstate.description.trim());

        // if (!teamId) {
        //     Http.post(`/team/create/${orgId}`, formData).subscribe(
        //         () => {
        //             toast({type: 'success', message: formstate.name + " created successfully"})
        //             history.goBack();
        //         },
        //         err => {
        //             toast({type: 'error', message:'Error while creating team'})
        //         }
        //     );
        // } else {
        //     Http.put("/teams/" + teamId, formData).subscribe(
        //         () => {
        //             history.goBack();
        //         },
        //         () => { }
        //     );
        // }

        if (!props.data.id) {
            Http.post(`/team/create/${orgId || selectedOrgId}`, formData).subscribe(
                () => {
                    SuccessToast("Team created successfully")
                    props.setRefresh(!props.refresh)
                    props.setVisible(false)
                    setTeamErrors("");
                },
                err => {
                    if (err && err.message === "Team name already exists") {
                        setTeamErrors(err.message);
                    } else {
                        ErrorToast((err && err.message) ? err.message : 'Error while creating team')
                        props.setVisible(false)
                        setTeamErrors("");
                    }

                }
            );
        } else {
            Http.put(`/teams/${props.data.id}?orgId=${orgId || selectedOrgId}`, formData).subscribe(
                () => {
                    SuccessToast("Team updated successfully")
                    props.setRefresh(!props.refresh)
                    props.setVisible(false)
                    setTeamErrors("")
                },
                (err) => {
                    if (err && err.message === "Team name already exists") {
                        setTeamErrors(err.message);
                    } else {
                        ErrorToast((err && err.message) ? err.message : 'Error while updating team')
                        props.setVisible(false)
                        setTeamErrors("");
                    }
                }
            );
        }
    };

    // const history = useHistory();

    return (
        <Modal
            id="createTeam"
            dataTestId="create_team"
            title="CREATE TEAM"
            footer={{
                enable: true,
                cancelText: 'CANCEL',
                okText: props.data.length > 0 ? 'SAVE' : 'CREATE',
                onOk: handleOK
            }}
            unmountOnCancel={true}
            onCancel={() => {props.setVisible(false); setPrevTeamName(""); setTeamErrors("")}}
            visible={props.visible}
        >
            {/* <Icon
                onClick={() => {
                    history.goBack();
                }}
                type="arrow-left"
                style={{ fontSize: "35px", color: "black", cursor: "pointer" }}
            /> */}
            {/* <div className={style.maindiv}>
                <div className={style.editCreateSub}>
                    <h3 className={style.modelTitle}>{!teamId ? "Create a Team" : "Edit Team"}</h3>
                    <Divider /> */}
            <Form {...formItemLayout} className={style.app + ' override-content'}>
                <Form.Item
                    hasFeedback={false}
                    validateStatus={valstate.name ? "error" : ""}
                    help={valstate.name}
                    label='Name'
                >
                    <Input
                        data-test-id="name"
                        value={formstate.name}
                        onChange={formsetState("name")}
                    />
                    {teamErrors && <div style={{color:"#EB001B", fontSize:"15px", marginTop:"12px"}}>{teamErrors}</div>}
                </Form.Item>
                {/* <Form.Item
              label={<span className={style.labelName}>Primary Email</span>}
            >
              <Input
                defaultValue={formstate.primaryEmail && formstate.primaryEmail}
                onChange={formsetState("primaryEmail")}
              />
            </Form.Item> */}
                <Form.Item
                    hasFeedback
                    validateStatus={valstate.description ? "error" : ""}
                    help={valstate.description}
                    label='Description'
                >
                    <TextArea
                        data-test-id="description"
                        value={formstate.description}
                        onChange={formsetState("description")}
                        rows={4}
                    />
                </Form.Item>

                {/* <Form.Item
                    validateStatus={valstate.img && "error"}
                    help={<div style={{ marginTop: "-22px" }}>{valstate.img}</div>}
                    label='Avatar'
                >
                    <Upload
                        data-test-id="avatar"
                        openFileDialogOnClick={state.editing}
                        name="avatar"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        beforeUpload={beforeUpload}
                        onChange={handleChange}
                    >
                        {formstate.img ? (
                            <React.Fragment>
                                <img
                                    src={formstate.img}
                                    alt="avatar"
                                    style={{ width: "100%" }}
                                />
                                {state.loading && formstate.img && (
                                    <React.Fragment>
                                        <Icon type={state.loading ? "loading" : "plus"} />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        ) : (
                            <div>
                                <Icon type={state.loading ? "loading" : "plus"} />
                                <div data-test-id="upload" className="ant-upload-text">Upload</div>
                            </div>
                        )}
                    </Upload>
                </Form.Item> */}

                {/* <div className={"row " + style.footer} key={"footer-1"}>
                            <button
                                className={style.cancel}
                                onClick={() => history.goBack()}
                            >
                                Cancel
                            </button>
                            <button className={style.create} onClick={handleOK}>
                                {teamId ? "Update" : "Create"}
                            </button>
                        </div> */}
            </Form>
        </Modal >
    );
};

export default EditCreateTeam;
